



























































import { Component, Vue, Prop, Ref } from "vue-property-decorator";

@Component({
    components: {
        FormBase: () => import("../forms/Base.vue"),
        FormInput: () => import("../forms/Input.vue"),
        FormCheckbox: () => import("../forms/Checkbox.vue")
    }
})
export default class contactForm extends Vue {
    @Prop({ default: "Praten?" }) title!: string;

    @Prop({ default: "false" }) estateContact!: string;

    @Prop({ default: "" }) estateUrl!: string;

    @Prop({ default: "" }) estateAddress!: string;

    @Prop({ default: "" }) sweepbrightId!: string;

    @Prop({ default: "Heb je een vraag? Neem gerust vrijblijvend contact op." }) content!: string;

    @Ref() readonly contactForm!: FormClass;

    payload: WordpressContact = {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        message: "",
        estate_url: "",
        estate_address: ""
    };

    translatedLabel: string = "#wijlancerenuwwoning";

    mounted() {
        // @ts-ignore
        if (Weglot) {
            const originalLabel = ["wij lanceren uw woning"];
            const self = this;
            // @ts-ignore
            Weglot.on("initialized", function() {
                if (document.documentElement.lang === "nl") return;
                // @ts-ignore
                Weglot.translate(
                    {
                        words: originalLabel.map(word => {
                            return { t: 1, w: word.toLowerCase() };
                        }),
                        languageTo: document.documentElement.lang
                    },
                    function(data: string[]) {
                        self.translatedLabel = `#${data.join("").toLowerCase().replace(/\s/g, "")}`;
                    }
                );
            });
        }
    }

    private submitForm() {
        this.payload.sweepbright_id = this.sweepbrightId;
        this.payload.estate_url = this.estateUrl;
        this.payload.estate_address = this.estateAddress;

        // @ts-ignore
        axios
            .post(this.estateContact == "true" ? "/api/forms/estate-contact" : "/api/forms/contact", this.payload)
            .then((response: any) => {
                this.contactForm.handleSuccess();
                this.payload = {
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: "",
                    message: "",
                    estate_url: "",
                    estate_address: ""
                };
                this.contactForm.reset();
            })
            .catch((e: { response: { data: ErrorResponse } }) => {
                this.contactForm.handleErrors(e.response.data);
            });
    }
}
